import { useEffect, useRef } from 'react';

import windowOnViewPromise from 'client/utils/windowOnViewPromise';

export default function useInitAbortHelper() {
    const helperRef = useRef({
        isAborted: false,
        checkIsDocOnViewing: () => windowOnViewPromise(),
        async canContinue() {
            return !this.isAborted && this.checkIsDocOnViewing();
        }
    });

    useEffect(() => {
        function handleUnload() {
            helperRef.current.isAborted = true;
            return null;
        }
        window.addEventListener('beforeunload', handleUnload);
        return () => {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            helperRef.current.isAborted = true;
            window.removeEventListener('beforeunload', handleUnload);
        };
    }, []);

    return helperRef;
}
